<mat-toolbar role="heading" id="app-toolbar" [ngClass]="toolbarEnvClass" style="padding: 0 0.25em">
    <div class="flex items-center flex-auto">
        <mat-icon
            [title]="liveUpdateConnectedStatusText()"
            style="margin: 0 4px; user-select: none; -webkit-text-stroke: 1px #fff"
            [style.color]="liveUpdateConnectedStatusColor()"
            >circle</mat-icon
        >
        @if (showBookerButton()) {
            <a mat-button routerLink="/tenant-list">Rax<span style="font-weight: bold">Booker</span></a>
        }
        @if (showLocationNameButton()) {
            <a mat-button [routerLink]="['/t', this.tenantIdCode()]">
                {{ activeLocationName() }}
            </a>
        }
    </div>

    <button mat-icon-button (click)="onOpenAppSideMenuButtonClick()">
        <mat-icon>person</mat-icon>
    </button>
</mat-toolbar>
